import React from 'react';
import MasterclassIndex from '../../masterclass/health';

export default function () {
  return <MasterclassIndex noFixedVideo noExitIntent variant="ad" entry="health" />;
}
